import { render, staticRenderFns } from "./statisticsNews.vue?vue&type=template&id=54be2f5c&scoped=true&"
import script from "./statisticsNews.vue?vue&type=script&lang=js&"
export * from "./statisticsNews.vue?vue&type=script&lang=js&"
import style0 from "./statisticsNews.vue?vue&type=style&index=0&id=54be2f5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be2f5c",
  null
  
)

export default component.exports